import React, { useEffect, useRef, useState } from "react";
import { STATS } from "../mock";

const useCountUp = (target, active, duration = 1600) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      setVal(Math.floor(p * target));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, active, duration]);
  return val;
};

const StatItem = ({ s, active }) => {
  const v = useCountUp(parseInt(s.value, 10), active);
  return (
    <div className="text-center px-4">
      <div className="font-display text-[#c8232c] text-6xl md:text-7xl leading-none">
        {v}
        <span className="text-stone-800">{s.suffix}</span>
      </div>
      <p className="mt-4 text-stone-600 text-sm md:text-base max-w-xs mx-auto leading-relaxed">
        {s.label}
      </p>
    </div>
  );
};

const Stats = () => {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setActive(true);
          obs.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="stats"
      ref={ref}
      className="relative py-24 bg-cover bg-center"
      style={{
        backgroundImage:
          "linear-gradient(rgba(255,255,255,0.85), rgba(255,255,255,0.92)), url('https://images.unsplash.com/photo-1600189083288-89e1c8b9b0cc?w=2000&q=70')",
      }}
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10">
        <h2 className="text-center font-display text-3xl md:text-4xl text-stone-800 mb-12">
          Did you know?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-6 items-start">
          {STATS.map((s, i) => (
            <StatItem key={i} s={s} active={active} />
          ))}
        </div>
        <div className="text-center mt-14">
          <a href="#benefits" className="btn-primary">Getting to know nuts better</a>
        </div>
      </div>
    </section>
  );
};

export default Stats;
